import { FC, Dispatch, useState, useEffect } from "react";
import { UserStateInterface } from "../../../middleware/interfaces/user/user-state-interface";
import { UserDecisionInterface } from "../../../middleware/interfaces/user/user-decision-interface";
import { ProjectInterface } from "../../../middleware/interfaces/project/project-interface";
import { FormatDateFE } from "../../../helper/general/methods";
import { ProjectDeleteInterface } from "../../../middleware/interfaces/project/project-delete-interface";
import { ProjectDownloadInterface } from "../../../middleware/interfaces/project/project-download-interface";
import { PingServerWithLastActionDate } from "../../../helper/ui/methods";
import MenuButton from "../user/menu-button";

interface projectInfoProps {
  state: UserStateInterface;
  selectedProject: ProjectInterface;
  setProjectShareDialogReveal: Dispatch<any>;
  setProjectEditDialogReveal: Dispatch<any>;
  dispatch: Dispatch<any>;
}

const ProjectInfo: FC<projectInfoProps> = ({
  state,
  selectedProject,
  setProjectShareDialogReveal,
  setProjectEditDialogReveal,
  dispatch,
}) => {
  const [openProject, setOpenProject] = useState(false);
  const [projectDeleteDialogReveal, setProjectDeleteDialogReveal] =
    useState(false);
  const [projectDownload, setProjectDownload] = useState(false);
  const [projectEdit, setProjectEdit] = useState(false);

  useEffect(() => {
    if (openProject === true) {
      const updatedUser = state.user;
      updatedUser!.openProject = selectedProject;
      dispatch({
        type: "UPDATE_USER",
        payload: updatedUser,
        response: "",
      });
      //PING SERVER TO UPDATE THE SESSION
      PingServerWithLastActionDate(updatedUser!);
      setOpenProject(false);
    }
  }, [openProject]);

  useEffect(() => {
    if (projectDeleteDialogReveal) {
      const projectDeleteData: ProjectDeleteInterface = {
        email: state.user?.email!,
        projectID: selectedProject!.projectID!,
        projectUserRole: selectedProject!.projectUserRole,
        type: "ProjectDeleteInterface",
      };
      const decision: UserDecisionInterface = {
        title: "Delete Project",
        message:
          "You have selected a project to delete. Are you sure you want to continue?",
        decisionOptions: ["DELETE_PROJECT", "NO_ACTION"],
        result: "",
        data: projectDeleteData,
        type: "UserDecisionInterface",
      };
      dispatch({ type: "DECISION", decision: decision });
    }
    setProjectDeleteDialogReveal(false);
  }, [projectDeleteDialogReveal]);

  useEffect(() => {
    if (projectDownload === true) {
      const projectDownloadData: ProjectDownloadInterface = {
        email: state.user!.email,
        projectID: selectedProject!.projectID!,
        projectUserRole: selectedProject!.projectUserRole,
        type: "ProjectDownloadInterface",
      };
      const decision: UserDecisionInterface = {
        title: "Download Project",
        message:
          "You have selected a project to download. Are you sure you want to continue?",
        decisionOptions: ["DOWNLOAD_PROJECT", "NO_ACTION"],
        result: "",
        data: projectDownloadData,
        type: "UserDecisionInterface",
      };
      dispatch({ type: "DECISION", decision: decision });
    }
    setProjectDownload(false);
  }, [projectDownload]);

  useEffect(() => {
    if (projectEdit === true) {
      setProjectEditDialogReveal("EDIT");
    }
    setProjectEdit(false);
  }, [projectEdit]);

  return (
    <>
      {(() => {
        if (selectedProject) {
          return (
            <div className="itemDetails">
              <span> Project: {selectedProject.projectName} </span>
              <span> Location: {selectedProject.projectLocation} </span>
              <span>
                Start Date:{" "}
                {FormatDateFE(selectedProject.projectStartDate!, true)}
              </span>
              <span>
                End Date: {FormatDateFE(selectedProject.projectEndDate!, true)}
              </span>
              <span>
                Created:{" "}
                {FormatDateFE(selectedProject.projectCreationDate!, true)}
              </span>
              <span> Role: {selectedProject.projectUserRole} </span>
              <span> Owner: {selectedProject.email} </span>
              <span> Description: {selectedProject.projectDescription} </span>
              <div className="horizontalDetailsOptionWrapper">
                <div className="menuButton">
                  <img
                    className="icon-small"
                    src="assets/icons/enter.png"
                    alt="OPEN"
                    onClick={() => {
                      setOpenProject(true);
                    }}
                  />
                </div>
                {selectedProject.projectUserRole !== "USER" ? (
                  <MenuButton
                    imageSource="assets/icons/share.png"
                    alternativeText="SHARE"
                    buttonSize="small"
                    dispatch={() => {
                      setProjectShareDialogReveal(true);
                    }}
                  />
                ) : (
                  <></>
                )}
                {selectedProject.projectUserRole !== "USER" ? (
                  <MenuButton
                    imageSource="assets/icons/team.png"
                    alternativeText="TEAM"
                    buttonSize="small"
                    dispatch={() => {
                      dispatch({
                        type: "RETRIEVE_PROJECT_TEAM",
                        payload: {
                          email: state.user!.email,
                          projectUserRole: selectedProject!.projectUserRole,
                          projectID: selectedProject!.projectID!,
                          type: "ProjectTeamRetrieveInterface",
                        },
                      });
                    }}
                  />
                ) : (
                  <></>
                )}
                <MenuButton
                  imageSource="assets/icons/download.png"
                  alternativeText="DOWNLOAD"
                  buttonSize="small"
                  dispatch={() => {
                    setProjectDownload(true);
                  }}
                />
                {selectedProject.projectUserRole !== "USER" ? (
                  <MenuButton
                    imageSource="assets/icons/edit.png"
                    alternativeText="EDIT"
                    buttonSize="small"
                    dispatch={() => {
                      setProjectEdit(true);
                    }}
                  />
                ) : (
                  <></>
                )}
                <MenuButton
                  imageSource="assets/icons/delete.png"
                  alternativeText="DELETE"
                  buttonSize="small"
                  dispatch={() => {
                    setProjectDeleteDialogReveal(true);
                  }}
                />
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default ProjectInfo;
